module.exports = __webpack_public_path__ + "static/media/FB_mobile.acfe6a6a.svg";